module.exports = __webpack_public_path__ + "img/money_cashback.43208a66.svg";